import { render, staticRenderFns } from "./changeDingjinMoneyAdd.vue?vue&type=template&id=6e6945a6&scoped=true&"
import script from "./changeDingjinMoneyAdd.vue?vue&type=script&lang=js&"
export * from "./changeDingjinMoneyAdd.vue?vue&type=script&lang=js&"
import style0 from "./changeDingjinMoneyAdd.vue?vue&type=style&index=0&id=6e6945a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6945a6",
  null
  
)

export default component.exports